import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.colors.body};
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.font};
    transition: all 0.20s linear;
    display: flex;
    flex-direction: column;
    width: 100vw;
    margin-inline: auto;
  }

  a {
    color: ${({ theme }) => theme.colors.link.text};
    cursor: pointer;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }

  label {
    margin-block-end: 10px;
  }

  button {
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.button.background};
    color: ${({ theme }) => theme.colors.button.text};
    -webkit-tap-highlight-color: transparent;
    font-family: ${({ theme }) => theme.font};

    :disabled {
      background-color: ${({ theme }) => theme.colors.button.disabled};
    }
  }
  
  input {
    border: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    color: ${({ theme }) => theme.colors.text};
    
    outline: transparent;
    &:focus{
      border-bottom: 1px solid ${({ theme }) => theme.colors.button.background};
    }
  }
`;
